import { render, staticRenderFns } from "./HomeShop.vue?vue&type=template&id=538122d2&scoped=true&"
import script from "./HomeShop.vue?vue&type=script&lang=js&"
export * from "./HomeShop.vue?vue&type=script&lang=js&"
import style0 from "./HomeShop.vue?vue&type=style&index=0&id=538122d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538122d2",
  null
  
)

export default component.exports